import React, { useContext, useState, useEffect } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/cart_cross_icon.png';
import { useNavigate } from 'react-router';

const CartItems = () => {
  const { getTotalCartAmount, all_product, setAll_Product, cartItems, removeFromCart } = useContext(ShopContext);
  const navigate = useNavigate();
  const token = localStorage.getItem("auth-token");

  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [couponMessage, setCouponMessage] = useState("");
  const [decorations, setDecorations] = useState(() => {
    return JSON.parse(localStorage.getItem("decorations") || '{}');
  });


  useEffect(() => {
    const missingItems = Object.keys(cartItems)
      .filter((itemId) => cartItems[itemId] > 0 && !all_product.find(p => p.id === Number(itemId)));
  
    missingItems.forEach((itemId) => {
      fetch(`/api/product/${itemId}`)
        .then(res => res.json())
        .then(data => {
          if (data && data.id) {
            setAll_Product(prev => [...prev, data]);
          }
        });
    });
  }, [cartItems, all_product, setAll_Product]);

  const handleDecorationChange = (itemId, type) => {
    const updated = {
      ...decorations,
      [itemId]: {
        ...decorations[itemId],
        [type]: !decorations[itemId]?.[type]
      }
    };
    setDecorations(updated);
    localStorage.setItem("decorations", JSON.stringify(updated));
  };

  const totalDecorationCost = Object.entries(cartItems).reduce((sum, [itemId, quantity]) => {
    const qty = Number(quantity);
    const decor = decorations[itemId] || {};
    if (qty > 0) {
      if (decor.felirat) sum += qty * 1000;
      if (decor.logo) sum += qty * 1100;
    }
    return sum;
  }, 0);

  return (
    <div className='cartitems'>
      <div className="cartitem-format-main">
        <p>Termékek</p>
        <p>Név</p>
        <p>Ár</p>
        <p>Szín/Méret</p>
        <p>Mennyiség</p>
        <p>Összesen</p>
      </div>
      <hr />
      {Object.entries(cartItems).map(([itemId, quantity]) => {
        if (quantity > 0) {
          const item = all_product.find(p => p.id === Number(itemId));
          if (!item) return null;

          const name = item.parentId
            ? all_product.find(p => p.id === item.parentId)?.name || item.name
            : item.name;

          const extras = item.variantAttributes
            ? `${item.variantAttributes.color || ""} / ${item.variantAttributes.size || ""}`
            : "";

          const itemDecor = decorations[itemId] || {};

          return (
            <div key={itemId}>
              <div className="cartitems-format cartitem-format-main">
                <img src={item.image} alt="" className='carticon-product-icon' />
                <p>{item.name}</p>
                <p>{item.price} FT</p>
                <p>{extras}</p>
                <button className='cartitems-quantity'>{quantity}</button>
                <p>{item.price * quantity} FT</p>
                <img
                  className='cartitems-remove-icon'
                  src={remove_icon}
                  onClick={() => removeFromCart(item.id)}
                  alt=""
                />
              </div>
              <div className="cartitems-dekor-options">
                <label>
                  <input
                    type="checkbox"
                    checked={itemDecor.felirat || false}
                    onChange={() => handleDecorationChange(itemId, "felirat")}
                  />
                  Felirat (+1000 Ft / db)
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={itemDecor.logo || false}
                    onChange={() => handleDecorationChange(itemId, "logo")}
                  />
                  Logó (+1100 Ft / db)
                </label>
              </div>
              <hr />
            </div>
          );
        }
        return null;
      })}

      <div className="cartitems-down">
        <div className="cartitems-total">
          <h1>Összegzés</h1>
          <div>
            <div className="cartitems-total-item">
              <p>Részösszeg</p>
              <p>{getTotalCartAmount()} FT</p>
            </div>
            <div className="cartitems-total-item">
              <p>Dekoráció összesen</p>
              <p>{totalDecorationCost} FT</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <p>Szállítási költség</p>
              <p>2000 FT</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <h3>Összesen</h3>
              {(getTotalCartAmount() - (getTotalCartAmount() * (discount / 100)) + 2000 + totalDecorationCost).toFixed(0)} FT
            </div>
          </div>
          <button
            onClick={() => navigate('/shipping')}
            disabled={!token}
            style={{ opacity: !token ? 0.6 : 1, cursor: !token ? 'not-allowed' : 'pointer' }}
          >
            Tovább a fizetéshez
          </button>
          {!token && (
            <p style={{ color: 'red', marginTop: '10px' }}>
              A rendelés leadásához kérlek <b>jelentkezz be</b>!
            </p>
          )}
        </div>

        <div className="cartitems-promocode">
          <p>Amennyiben rendelkezel kuponkóddal írd be ide:</p>
          <div className="cartitems-promobox">
            <input
              type="text"
              placeholder="KUPONKÓD"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
            />
            <button
              onClick={async () => {
                const res = await fetch("/api/verifycoupon", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ code: couponCode }),
                });

                const data = await res.json();

                if (data.valid) {
                  setDiscount(data.discountPercentage);
                  setCouponMessage(`🎉 Sikeres beváltás! Kedvezmény: ${data.discountPercentage}%`);
                  localStorage.setItem("couponCode", couponCode);
                  localStorage.setItem("discountPercentage", data.discountPercentage);
                } else {
                  setDiscount(0);
                  setCouponMessage("❌ Érvénytelen kuponkód.");
                  localStorage.removeItem("couponCode");
                  localStorage.removeItem("discountPercentage");
                }
              }}
            >
              Beváltás
            </button>
          </div>
          {couponMessage && (
            <p style={{ marginTop: "80px", color: discount > 0 ? "green" : "red" }}>{couponMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartItems;